import { useCallback } from 'react';

import { DosageTemplateDeleteCommand } from '@dreryk/egabinet-prescription-frontend-api';

import { PromiseVoidFunction, sortBeanAlphabetically } from '@dreryk/react-common';

import { FormsTemplates, FormsTemplateSortItemsFn } from '~libs.desktop.shared.user-templates.forms';

import { extendedDosageTemplatesTranslationKeys } from '../../../../translations';

import { DosageTemplateListItem } from './DosageTemplates.types';

const sortDosageTemplates: FormsTemplateSortItemsFn<DosageTemplateListItem> = (items, sortOrder) =>
   sortBeanAlphabetically(items, 'name', sortOrder, '');

type DosageTemplatesListProps = {
   readonly onTemplateRemoved: PromiseVoidFunction;
};

export const DosageTemplatesList = (props: DosageTemplatesListProps): JSX.Element => {
   const removeCommandCreator = useCallback((templateId) => {
      const command = new DosageTemplateDeleteCommand();
      command.id = templateId;
      return command;
   }, []);

   return (
      <FormsTemplates.List<DosageTemplateListItem>
         onTemplateRemoved={props.onTemplateRemoved}
         sortFn={sortDosageTemplates}
         removeConfirmationTitle={extendedDosageTemplatesTranslationKeys.removingTemplate}
         removeSuccessMessage={extendedDosageTemplatesTranslationKeys.templateRemovedSuccessfully}
         removeCommandCreator={removeCommandCreator}
         testId={'dosageTemplates'}
      />
   );
};
